<div #searchContainer fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem" class="border rounded px-3 py-2 border-primary"
    style="position: relative">
    <mat-icon class="text-primary">search</mat-icon>
    <input #inputSearch matInput [(ngModel)]="inputKeyword" [matAutocomplete]="auto"
        (keydown.enter)="handleEnter($event)" placeholder="Search..." class="input-search-agolia" />
    <!-- <span class="custom-suffix" *ngIf="inputKeyword">Total: {{state.indices[0]['results']['nbHits'] | numberFormat}}</span> -->
    <button mat-icon-button (click)="handleClean()" class="text-danger clean-button">
        <mat-icon>close</mat-icon>
    </button>
    <button mat-icon-button (click)="handleRefresh()" class="clean-button">
        <mat-icon>refresh</mat-icon>
    </button>
    <mat-autocomplete #auto="matAutocomplete" style="margin-top: 30px; max-height: 600px" class="algolia-option"
        (autocompleteScroll)="onScroll()" [isLoading]="isNext" (opened)="opened()" [disableLoading]="disableNext">
        <div *ngIf="isNext" class="loader">
            <div class="loading-bar"></div>
        </div>
        <div *ngFor=" let index of state.indices || []">
            <mat-option *ngFor="let option of index.hits" [value]="option[propDisplay]"
                (click)="handleClick(option[propDisplay])">
                <ng-container *ngIf="option?.['_highlightResult'] as highLight">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <div>
                            <span class="title"
                                [innerHtml]="((highLight?.[propDisplay]?.value || option?.[propDisplay]) | parseSafeHtml) | safeHtml">
                            </span>
                            <br>
                            <span class="sub-title"
                                [innerHtml]="((highLight?.['realName']?.value || option?.['realName']) | parseSafeHtml) | safeHtml">
                            </span>
                            <ng-container *ngIf="highLight?.['private_contactFullname']?.value || option?.['private_contactFullname'] ">
                                <br>
                                <mat-icon class="autocomplete_icon">person</mat-icon>
                                <span class="children-sub-title"
                                    [innerHtml]="((highLight?.['private_contactFullname']?.value || option?.['private_contactFullname']) | parseSafeHtml) | safeHtml">
                                </span>
                            </ng-container>

                            <ng-container *ngIf="highLight?.['private_contactEmail']?.value || option?.['private_contactEmail']">
                                <br>
                                <mat-icon class="autocomplete_icon">email</mat-icon>
                                <span class="children-sub-title"
                                    [innerHtml]="((highLight?.['private_contactEmail']?.value || option?.['private_contactEmail']) | parseSafeHtml) | safeHtml">
                                </span> 
                            </ng-container>
  
                            <ng-container *ngIf="highLight?.['private_contactPhone']?.value || option?.['private_contactPhone']">
                                <ng-container *ngIf="((highLight?.['private_contactEmail']?.value) || option?.['private_contactEmail']); else breakline"> | </ng-container>
                                <ng-template #breakline><br></ng-template>
                                
                                <mat-icon class="autocomplete_icon">phone</mat-icon>
                                <span class="children-sub-title" 
                                    [innerHtml]="((highLight['private_contactPhone']?.value || option['private_contactPhone']) | parseSafeHtml) | safeHtml">
                                </span>
                            </ng-container>

                        </div>
                        <div class="ml-auto">
                            <button mat-icon-button (click)="onQuerySuggestionClick.emit(option[propValue])">
                                <mat-icon>east</mat-icon>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </mat-option>
        </div>
    </mat-autocomplete>
</div>
